import { motion } from "framer-motion";
import { fadeUp, stagger } from "../lib/motion";

const STEPS = [
  { no: "01", title: "Request Audit", body: "Two minutes. Tell us about your business — no calls, no commitment." },
  { no: "02", title: "We Diagnose the Gaps", body: "We review your brand, website and acquisition path, and find what's leaking clients." },
  { no: "03", title: "Review Your Growth Plan", body: "You get a clear, prioritized plan — the highest-impact fixes first." },
  { no: "04", title: "Decide If We're the Right Partner", body: "No pressure. The plan is yours either way." },
];

export const NextSteps = () => (
  <section className="relative py-24 lg:py-32" data-testid="next-steps-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }} variants={stagger}>
        <motion.p variants={fadeUp} className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] mb-5">
          / What Happens Next
        </motion.p>
        <motion.h2 variants={fadeUp} className="text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-14">
          Ridiculously simple.
        </motion.h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#2A2D34] border border-[#2A2D34]">
          {STEPS.map((s) => (
            <motion.div key={s.no} variants={fadeUp} className="group bg-[#0A0C0F] p-8 lg:p-9 hover:-translate-y-1 transition-transform duration-300" data-testid={`next-step-${s.no}`}>
              <p className="text-5xl font-black text-stroke-lime leading-none transition-colors duration-300 group-hover:text-[#C6FF00]">{s.no}</p>
              <h3 className="mt-6 text-lg font-black uppercase tracking-tight text-white">{s.title}</h3>
              <span className="mt-3 block h-0.5 w-8 bg-[#C6FF00] transition-all duration-300 group-hover:w-16" />
              <p className="mt-4 text-sm text-[#8A939B] font-medium leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
